// src/sentry.ts
import { init } from "@sentry/react";
import { PRODUCTION, SENTRY_ENDPOINT, SENTRY_RELEASE } from "@/constants/settings.ts";

init({
  dsn: SENTRY_ENDPOINT,
  replaysOnErrorSampleRate: 0.1,
  beforeSend: (event) => {
    if (
      event.transaction?.includes("Transition was aborted because of invalid state") ||
      event.transaction?.includes("View transition was skipped")
    ) {
      return null;
    }
    return event;
  },
  enabled: PRODUCTION,
  release: SENTRY_RELEASE,
});
